import { MenuItem, TextField } from '@mui/material'
import { MESSAGE_TEMPLATES, MessageTemplate } from './messageTemplates'

type Props = { onPick: (template: MessageTemplate) => void }

/** The "תבנית הודעה" dropdown. It renders nothing while the fixed list is empty. */
const MessageTemplateSelect = ({ onPick }: Props) => {
  if (MESSAGE_TEMPLATES.length === 0) return null
  return (
    <TextField
      select
      size="small"
      label="תבנית הודעה"
      value=""
      sx={{ minWidth: 180, flex: 1 }}
      slotProps={{
        select: { MenuProps: { slotProps: { paper: { dir: 'rtl' } } } },
      }}
    >
      {MESSAGE_TEMPLATES.map(template => (
        <MenuItem
          key={template.id}
          value={template.id}
          onClick={() => onPick(template)}
        >
          {template.name}
        </MenuItem>
      ))}
    </TextField>
  )
}

export default MessageTemplateSelect
